var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStempel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stempel__Icn/40px/Stempel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stempel__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Stempel__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stempel__Icn/40px/Plus-Tools",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Stempel__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,8 C22.7614237,8 25,10.2385763 25,13 C25,14.6352792 24.2149639,16.0872034 23.0011995,16.9994649 L23,21 L26,21 C28.209139,21 30,22.790861 30,25 L30,30 L10,30 L10,25 C10,22.790861 11.790861,21 14,21 L17,21 L16.9998057,17.0002202 C15.8394177,16.128531 15.0706371,14.7637023 15.0046195,13.2168896 L15,13 C15,10.2385763 17.2385763,8 20,8 Z M28,27 L12,27 L12,28 L28,28 L28,27 Z M20,10 C18.4023191,10 17.0963391,11.24892 17.0046861,12.785541 L16.9995465,12.9574118 L17.0028004,13.1316078 C17.0384867,13.9677482 17.4189224,14.7355526 18.0406417,15.2719591 L18.2010384,15.4011455 L18.9997571,16.0011469 L19.0000972,23 L14,23 C12.9456382,23 12.0818349,23.8158778 12.0054857,24.8507377 L12,25 L28,25 C28,23.9456382 27.1841222,23.0818349 26.1492623,23.0054857 L26,23 L20.9994003,23 L21.0014989,16.0005161 L21.7995662,15.4006912 C22.5512836,14.8357028 23,13.9570134 23,13 C23,11.3431458 21.6568542,10 20,10 Z",
    id: ".._.._src_svg_Icn_40px_Stempel__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStempel);
export default __webpack_public_path__ + "static/media/Stempel.56ef3aa0ed1365ce27e70da0d3d1e0a9.svg";
export { ForwardRef as ReactComponent };